module.exports = __webpack_public_path__ + "static/social_relations-1255a001efa8e79b086e159f54053881.jpg";